import { Col, Container, Row, Table } from "react-bootstrap";
import { Jumbotron } from "sections";
import "styles/page.css";
import e_application_form_header from "assets/images/e_application_form_header.png";
import { eApplicationForm } from "constants/e-applicationForm";
import { AccordionGeneral } from "components/accordion";

function ApplicationForm() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="e-Application Form"
          title={`e-Application <span className="jumbotron-subtitle-2">Form<span>`}
          backgroundImage={e_application_form_header}
        />
      </section>
      <section className="e-application-form" id="virtual-banking" style={{ height: "auto" }}>
        <Container>
          <Row>
            <Col>
              <AccordionGeneral list={eApplicationForm} />
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="my-5 py-5">
                <h3>Checklist of Forms</h3>
                <Table bordered responsive className="mt-4">
                  <thead>
                    <tr>
                      <th>Forms to be filled up</th>
                      <th>Qard Current Account-i</th>
                      <th>Qard Savings Account-i</th>
                      <th>Qard Foreign Currency Current Account-i</th>
                      <th>Commodity Murabahah Current Account-i</th>
                      <th>Commodity Murabahah Savings Account-i</th>
                      <th>Commodity Murabahah Term Deposit-i</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Account Opening / Placement Form Individual/Joint</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                    </tr>
                    <tr>
                      <td>Tax Residency Form</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                    </tr>
                    <tr>
                      <td>Debit Card Agreement</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Agency Appointment Form</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                    </tr>
                    <tr>
                      <td>Investor Suitability and Risk Assessment Form</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td></td>
                      <td></td>
                      <td>✔</td>
                    </tr>
                    <tr>
                      <td>Agreement</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td>✔</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Agreement-FCA</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>✔</td>
                    </tr>
                    <tr>
                      <td>Declaration FCA</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>✔</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default ApplicationForm;
